// extracted by mini-css-extract-plugin
export var infoItem = "_m1-1";
export var title = "_m1-0";